import { RCCallout, RCButtonLink } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import React from 'react';
import I18n from 'i18n-js';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { COUNTRY_CODES } from '../shared/constants';
import { Paths } from './shared/url_helpers';
import { InfoIcon, QuestionIcon } from '@phosphor-icons/react';

const CA_HELP_CENTER_ARTICLE_ID = '7023355975955';
const CA_HELP_CENTER_ANCHOR = 'h_7';

interface Props {
  taxType: string;
  countryCode: string;
}

export const BannerContent = ({ countryCode, taxType }) => {
  if (countryCode == COUNTRY_CODES.CA) {
    return <Translate tag="p" text="discovery.internationalTaxIds.banner.caTaxContent" />;
  }

  return (
    <Translate tag="p" text="discovery.internationalTaxIds.banner.euAddTaxId">
      <Translate text={`discovery.internationalTaxIds.banner.${taxType}`} />
    </Translate>
  );
};

export function InternationalTaxIdBanner({ taxType, countryCode }: Props) {
  const isCanadian = countryCode === COUNTRY_CODES.CA;

  const buttonTextKey = isCanadian ? 'learnMore' : 'buttonText';

  const link = isCanadian ? Paths.helpCenterArticlesUrl.expand({ articleId: CA_HELP_CENTER_ARTICLE_ID, anchor: CA_HELP_CENTER_ANCHOR }) : '/my/selling/tax_policy';

  return (
    <RCCallout
      themeType="utility"
      variant="info-ultralight"
      icon={isCanadian ? <InfoIcon /> : <QuestionIcon />}
      title={isCanadian ? I18n.t('discovery.internationalTaxIds.banner.caTaxTitle') : undefined}
      cta={(
        <RCButtonLink
          variant="filled"
          renderLink={c => <CoreLink to={link}>{c}</CoreLink>}
        >
          <Translate text={`discovery.internationalTaxIds.banner.${buttonTextKey}`} />
        </RCButtonLink>
      )}
    >
      <BannerContent
        countryCode={countryCode}
        taxType={taxType}
      />
    </RCCallout>
  );
}

export default InternationalTaxIdBanner;
